import { render } from "./AboutContent.vue?vue&type=template&id=af3b8d36&scoped=true"
import script from "./AboutContent.vue?vue&type=script&lang=js"
export * from "./AboutContent.vue?vue&type=script&lang=js"

import "./AboutContent.vue?vue&type=style&index=0&id=af3b8d36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3b8d36"]])

export default __exports__